'use client';
var classes = {"weekday":"m_18a3eca"};

export { classes as default };
//# sourceMappingURL=WeekdaysRow.module.css.mjs.map
